import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Key, User } from 'lucide-react';
import '../../styles/Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  // Vérifie si un token existe = user connecté
  const isLoggedIn =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  // Fonction de navigation vers l'inscription selon rôle
  const handleRegistrationClick = (role) => {
    navigate("/register", { state: { role } });
  };

  return (
    <div className="hero-container">
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="scope-badge">
          🇫🇷 Action Nationale • Locataires & Propriétaires
        </div>

        <h1 className="hero-title">
          Résoudre les litiges de logement n'a jamais été aussi{" "}
          <span className="highlight-text">simple.</span>
        </h1>

        <p className="hero-subtitle">
          La première plateforme d'assistance juridique et de médiation{" "}
          <span className="highlight-text">augmentée par l'IA</span>. Que vous
          soyez locataire, bailleur, ou Citoyen, trouvez la solution dans
          l'écosystème NMS 06.
        </p>

        {/* ❗ Affiche les boutons UNIQUEMENT si pas connecté */}
        {!isLoggedIn && (
          <div className="hero-buttons role-buttons-grid">
            {/* BOUTON 1: LOCATAIRE */}
            <button
              className="btn-primary role-btn btn-tenant"
              onClick={() => handleRegistrationClick("tenant")}
            >
              <Home size={20} /> Espace Locataire
            </button>

            {/* BOUTON 2: PROPRIÉTAIRE */}
            <button
              className="btn-secondary role-btn btn-landlord"
              onClick={() => handleRegistrationClick("landlord")}
            >
              <Key size={20} /> Espace Propriétaire
            </button>

            {/* BOUTON 3: CITOYEN */}
            <button
              className="btn-tertiary role-btn btn-user"
              onClick={() => handleRegistrationClick("user")}
            >
              <User size={20} /> Espace Citoyen & Autre
            </button>
          </div>
        )}

        <p className="hero-footer-note">
          (Basé à Levens, notre action couvre Nice et les Alpes-Maritimes)
        </p>
      </div>
    </div>
  );
};

export default Hero;
